/* DIRTS Bridge advertorial — shared behavior.
   Loaded once on *bridge* templates. Bound by event delegation so it
   survives theme-editor section reorder / reload. Handles:
   - FAQ accordion
   - sticky CTA scroll reveal
   - smooth-scroll for any link to #bridge-offer
   - post-add redirect to checkout/cart (no cart drawer on this layout) */
(function () {
  'use strict';

  /* ── FAQ accordion (delegated) ── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.brg-faqq');
    if (!q) return;
    var item = q.closest('.brg-faqitem');
    if (!item) return;
    var panel = item.querySelector('.brg-faqa');
    var open = item.getAttribute('data-open') === 'true';

    var group = item.closest('.brg-faq') || document;
    group.querySelectorAll('.brg-faqitem[data-open="true"]').forEach(function (o) {
      if (o !== item) {
        o.setAttribute('data-open', 'false');
        var ob = o.querySelector('.brg-faqq');
        if (ob) ob.setAttribute('aria-expanded', 'false');
        var op = o.querySelector('.brg-faqa');
        if (op) op.style.maxHeight = '0px';
      }
    });

    item.setAttribute('data-open', String(!open));
    q.setAttribute('aria-expanded', String(!open));
    if (panel) panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
  });

  /* ── Smooth scroll to the offer (delegated, any section) ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#bridge-offer"]');
    if (!a) return;
    var target = document.getElementById('bridge-offer');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ── Colour swatch -> swap the main offer image ── */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.brg-swatch');
    if (!sw) return;
    var section = sw.closest('.brg-offer-section');
    if (!section) return;
    var img = section.querySelector('[data-brg-main-img]');
    var src = sw.getAttribute('data-brg-img');
    if (img && src) img.src = src;
    section.querySelectorAll('.brg-swatch.is-on').forEach(function (s) { s.classList.remove('is-on'); });
    sw.classList.add('is-on');
  });

  /* ── Editable size-guide pill -> open the bundle widget's size modal ── */
  document.addEventListener('click', function (e) {
    var sg = e.target.closest('.brg-sizeguide');
    if (!sg) return;
    var section = sg.closest('.brg-offer-section');
    if (!section) return;
    var trigger = section.querySelector('.brg-bw-host [data-bw-sc-top]');
    if (trigger) trigger.click();
  });

  /* ── Sticky CTA: reveal once scrolled past the first fold, but hide while the
     offer card (product + bundle) is on screen — no point covering the real buy box. ── */
  var stickyTicking = false;
  function onScroll() {
    if (stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(function () {
      var show = window.scrollY > window.innerHeight * 0.85;
      var offer = document.getElementById('bridge-offer');
      if (show && offer) {
        var r = offer.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) show = false;
      }
      document.querySelectorAll('.brg-sticky-cta').forEach(function (bar) {
        bar.classList.toggle('is-show', show);
      });
      stickyTicking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Post-add: let the theme cart drawer open (the bundle offer — free gift /
     tier discount — applies at the cart level, same as the product page). No redirect. ── */

  /* ── Re-run lightweight init when a section reloads in the editor ── */
  document.addEventListener('shopify:section:load', function () {
    onScroll();
  });
})();
